import type { ColumnDef } from '@tanstack/vue-table';
import dayjs from 'dayjs';
import { h } from 'vue';

import type { SMSThreadSummary } from '@stuut/api-sdk/models';
import { formatPhoneNumber } from '@stuut/common/src/utils';
import { DataTableColumnHeader } from '@ui/components/datatable';
import { Timestamp } from '@ui/components/time';

export const columns: ColumnDef<SMSThreadSummary>[] = [
  {
    accessorKey: 'latestMessageAt',
    cell: ({ row }) => {
      return h(Timestamp, {
        local: true,
        showFromNow: true,
        time: row.original.latestMessageAt ? dayjs(row.original.latestMessageAt).utc(true) : null,
        withConversionTable: true,
      });
    },
    enableSorting: true,
    header: ({ column }) => h(DataTableColumnHeader, { column, title: 'Last Message' }),
    size: 140,
  },
  {
    accessorKey: 'fromNumber',
    cell: ({ row }) => {
      const phoneNumber = row.original.fromNumber;
      const formattedNumber = formatPhoneNumber(phoneNumber);
      return h('div', { class: 'flex justify-center items-center' }, [
        h('span', formattedNumber || phoneNumber || '--'),
      ]);
    },
    enableSorting: false,
    header: ({ column }) =>
      h(DataTableColumnHeader, {
        class: 'justify-center',
        column,
        title: 'From',
      }),
    size: 140,
  },
  {
    accessorKey: 'toNumber',
    cell: ({ row }) => {
      const phoneNumber = row.original.toNumber;
      const formattedNumber = formatPhoneNumber(phoneNumber);
      return h('div', { class: 'flex justify-center items-center' }, [
        h('span', formattedNumber || phoneNumber || '--'),
      ]);
    },
    enableSorting: false,
    header: ({ column }) =>
      h(DataTableColumnHeader, {
        class: 'justify-center',
        column,
        title: 'To',
      }),
    size: 140,
  },
  {
    accessorKey: 'partner',
    cell: ({ row }) => {
      return h('span', row.original.partner?.name || '--');
    },
    enableSorting: false,
    header: ({ column }) => h(DataTableColumnHeader, { column, title: 'Partner Name' }),
    size: 150,
  },
  {
    accessorKey: 'latestMessageBody',
    cell: ({ row }) => {
      return h(
        'div',
        {
          class: 'truncate',
          title: row.original.latestMessageBody || '',
        },
        row.original.latestMessageBody || '--',
      );
    },
    enableSorting: false,
    header: ({ column }) =>
      h(DataTableColumnHeader, {
        column,
        title: 'Latest Message',
      }),
    maxSize: 400,
    size: 300,
  },
];

export default columns;
